import View from './view';

export const ProfileInfo = View;
